/**
 * 페이지네이션 스토어
 * - 페이지별 독립적인 페이지네이션 상태 관리
 * - 기존 전역 상태와 호환성 유지
 */

export default {
  namespaced: true,

  state: {
    // 기존 전역 상태 (호환성 유지)
    page: 1,
    firstItem: 0,
    itemsPerPage: 10,

    // 페이지별 상태 저장
    pages: {},
  },

  getters: {
    // 기존 getters (호환성 유지)
    page(state) {
      return state.page
    },
    firstItem(state) {
      return state.firstItem
    },
    itemsPerPage(state) {
      return state.itemsPerPage
    },

    /**
     * 특정 페이지의 상태 가져오기
     * @param {string} pageId - 페이지 식별자 (라우트 이름 등)
     */
    getPageState: (state) => (pageId) => {
      return (
        state.pages[pageId] || {
          page: 1,
          firstItem: 0,
          itemsPerPage: 10,
          sort: '',
          query: '',
        }
      )
    },

    /**
     * 모든 페이지 상태
     */
    allPages(state) {
      return state.pages
    },
  },

  mutations: {
    // 기존 mutation (호환성 유지)
    updateState(state, { page, firstItem, itemsPerPage }) {
      if (page !== undefined) state.page = page
      if (firstItem !== undefined) state.firstItem = firstItem
      if (itemsPerPage !== undefined) state.itemsPerPage = itemsPerPage
    },

    /**
     * 특정 페이지 상태 설정
     */
    setPageState(state, { pageId, pagination }) {
      state.pages = {
        ...state.pages,
        [pageId]: {
          ...state.pages[pageId],
          ...pagination,
        },
      }
    },

    /**
     * 특정 페이지 상태 삭제
     */
    clearPageState(state, pageId) {
      // eslint-disable-next-line no-unused-vars
      const { [pageId]: _, ...rest } = state.pages
      state.pages = rest
    },

    /**
     * 모든 페이지 상태 초기화
     */
    clearAllPages(state) {
      state.pages = {}
    },
  },

  actions: {
    // 기존 action (호환성 유지)
    setPagination(context, { page, firstItem, itemsPerPage }) {
      context.commit('updateState', {
        page,
        firstItem,
        itemsPerPage,
      })
    },

    /**
     * 페이지별 상태 설정
     * @param {string} pageId - 페이지 식별자
     * @param {Object} pagination - 페이지네이션 상태
     */
    setPagePagination(
      { commit },
      { pageId, page, firstItem, itemsPerPage, sort, query }
    ) {
      commit('setPageState', {
        pageId,
        pagination: {
          page,
          firstItem,
          itemsPerPage,
          sort,
          query,
        },
      })
    },

    /**
     * 페이지 상태 리셋
     * @param {string} pageId
     */
    resetPagePagination({ commit }, pageId) {
      commit('setPageState', {
        pageId,
        pagination: {
          page: 1,
          firstItem: 0,
          itemsPerPage: 10,
          sort: '',
          query: '',
        },
      })
    },

    /**
     * 페이지 상태 삭제
     * @param {string} pageId
     */
    removePagePagination({ commit }, pageId) {
      commit('clearPageState', pageId)
    },

    /**
     * 모든 페이지 상태 초기화
     */
    clearAll({ commit }) {
      commit('clearAllPages')
      commit('updateState', {
        page: 1,
        firstItem: 0,
        itemsPerPage: 10,
      })
    },
  },
}
